module.exports = "<div class=\"page\">\n    <div class=\"page-content container-fluid\">\n        <flash-messages></flash-messages>\n        <router-outlet></router-outlet>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/layouts/basic.template.html
// module id = ../../../../../src/app/layout/layouts/basic.template.html
// module chunks = 3